export default __webpack_public_path__ + "static/pour-d3fda800e6a72653a7bc9d28989d515d.png";